import React, { useMemo } from "react";
import { GamePiece } from "./GamePiece";

interface RootNodeProps {
  path: string[];
  value: any;
  pieceName: string;
  uniqueKey: string;
}

export function RootNode(props: RootNodeProps) {
  /// TODO check if this is necessary
  const memoValue = useMemo(() => {
    return JSON.stringify(props.value, null, 2);
  }, [props.value]);

  const gamePiece = useMemo(() => {
    return <GamePiece uniqueKey={props.uniqueKey} gamePieceName={props.pieceName} rawValue={memoValue} />;
  }, [props.pieceName, props.uniqueKey, memoValue]);

  return gamePiece;
}
